export const enum MySelectionPageTrackingEvent {
  REMOVE_PRODUCT_CLICKED = 'my-selection-remove-product-clicked',
}
